<template>
  <div class="iv-broadcast">
    <div class="iv-broadcast2" @click="todetail(contentList[0])">
      <img class="bg" :src="getImgPath(broadcastList.bgUrl)" @error="nofind" alt="BEZ微讯"/>
      <div class="iv-broadcast-container">
        <div class="iv-broadcast-left" v-if="newsDate">
          <p>{{ broadcastList.title }}</p>
          <p>{{newsDate.replaceAll('/','.')}}</p>
        </div>
        <!--      <div class="iv-broadcast-left">
                <p>{{ broadcastList.day }}</p>
                <p>{{ broadcastList.month }}</p>
                <p>{{ broadcastList.title }}</p>
              </div>-->
<!--        <div class="iv-broadcast-right">-->
<!--          <div class="iv-broadcast-each">-->
<!--            <p v-html="broadcastList.blogDesc?broadcastList.blogDesc.replace(/\n/g,'<br>'):''"-->
<!--               style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical; "></p>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <span class="iv-pointer" @click="goToList">...</span>
  </div>
</template>

<script>
import {newsPrefixPath} from '@/config'
import {timeFormat} from '@/utils'

export default {
  data() {
    return {
      broadcastList: {
        title: 'BEZ微讯',
        month: new Date().getFullYear() + '.' + (new Date().getMonth() + 1),
        day: new Date().getDate(),
        content: '',
        bgUrl: '~@/assets/images/news/broadcast.png'
      },
      contentList: [],
      newsDate: ''
    }
  },
  props: ['navData'],
  created() {
    this.getmanagerThought()
  },
  methods: {
    getmanagerThought() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'xwzbj',
          rowNum: '1'
        }
      }).then(({data}) => {
        this.contentList = data.data['xwzbj']
        if (this.contentList.length > 0) {
          this.broadcastList.bgUrl = this.contentList[0].guideBgImg
          this.broadcastList.title = this.contentList[0].title

          // this.getImgPath(this.contentList[0].guideBgImg)
          // let publishDate = new Date(this.contentList[0].publishDate)
          // this.broadcastList.month = publishDate.getFullYear() + '.' + (publishDate.getMonth() + 1)
          // this.broadcastList.day = publishDate.getDate()
          this.broadcastList.content = unescape(this.contentList[0].content)
          this.broadcastList.blogDesc = unescape(this.contentList[0].blogDesc)
          this.newsDate = unescape(this.contentList[0].publishTime)
        }
      })
    },
    getImgPath(id) {
      return id ? `${newsPrefixPath}file/downloadFile?fileId=${id}` : '~@/assets/images/news/broadcast.png'
    },
    getTime(d) {
      return timeFormat(d)
    },
    todetail(item) {
      if(item.id){
        const {href} = this.$router.resolve({
          name: 'newsDetail',
          query: {
            infoId: item.id ,
            categoryName:item.columnName
          }
        })
        window.open(href, '_blank')
      }

    },
    nofind() {
      var img = event.srcElement
      img.src = require('@/assets/images/news/broadcast.png')
      img.onerror = null
    },
    goToList(code, name) {
      console.log('this.navData>>>', this.navData)
      console.log('this.navData[\'xwzbj\']', this.navData['xwzbj'])
      const {href} = this.$router.resolve({
        name: 'xwzbj',
        query: {
          categoryCode: 'xwzbj',
          categoryName: 'BEZ微讯',
          categoryId: this.navData['daily_news_live'].categoryId,
          categoryType: this.navData['daily_news_live'].categoryType
        }
      })
      window.open(href, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.iv-broadcast {
  // height: 364px;
  margin-top: 24px;
  // background-image: url('~@/assets/images/news/broadcast.png');
  // background-size: cover;
  // background-position: center center;
  position: relative;
  z-index: 0;
  overflow: hidden;
}

.iv-broadcast2 {
  // height: 364px;
  // background-image: url('~@/assets/images/news/broadcast.png');
  // background-size: cover;
  // background-position: center center;
  position: relative;
  z-index: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .bg {
    width: 100%;
  }
  .iv-broadcast-container {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }

  .iv-broadcast-left {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 46px;
    font-family: "Microsoft YaHei";

    p:nth-of-type(1) {
      font-size: 42px;
      line-height: 1.2;
      font-weight: bold;
      color: #111A34;
    }

    p:nth-of-type(2) {
      font-size: 28px;
      color: #111A34;
      font-weight: bold;
    }

    p:nth-of-type(3) {
      margin: 16px 0 0 61px;
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      text-align: center;
      width: 120px;
    }
  }

  .iv-broadcast-right {
    font-family: "Microsoft YaHei";
    padding-top: 40px;
    padding: 40px 50px 0 50px;
    font-size: 14px;

    .iv-broadcast-each {
      margin-bottom: 16px;

      .iv-broadcast-title {
        font-size: 20px;
        color: #000000;

        span:nth-of-type(1) {
          width: 4px;
          height: 16px;
          background: #2373C8;
          border-radius: 2px;
          display: inline-block;
          margin-right: 7px;
        }
      }

      div {
        margin-top: 8px;
        font-size: 16px;
        color: #000000;
        margin-left: 5px;
      }

      p {
        font-size: 16px;
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        margin-right: 30px;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
    }

    .iv-broadcast-list {
      .iv-broadcast-item {
        margin-bottom: 15px;

        .iv-item-title {
          font-size: 20px;
          position: relative;
          padding-left: 10px;

          &::before {
            content: '';
            position: absolute;
            width: 4px;
            height: 16px;
            background: #2373C8;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            border-radius: 8px;
          }
        }

        .iv-item-content {
          ul {
            margin-top: 10px;

            li {
              cursor: pointer;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.64);
            }
          }
        }
      }
    }
  }


}

.iv-pointer {
  height: 4px;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 6px;
  position: absolute;
  right: 30px;
  top: 0;
}

.iv-broadcast::before {
  content: '';
  clear: both;
}
</style>
